export const QUERY_CACHE_TIME = 30 * 60 * 1000 // 30 min
export const QUERY_STALE_TIME = 15 * 60 * 1000 // 15 min

const USERS_BASE_PATH = "users"
export const USERS_SIGNIN_PATH = `${USERS_BASE_PATH}/sign_in`
